// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__2ezJA","notes":"Notes_notes__2RQKR","note":"Notes_note__3b0_m","markdown":"Notes_markdown__I6-mO"};